import { Component } from '@angular/core';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { StorageService } from '../../../core/storage/storageService';
import { Customer } from '../../../models/customer/customer';

@Component({
  selector: 'app-customer-account',
  templateUrl: './customer-account.component.html',
  standalone: false,
})
export class CustomerAccountComponent {
  //selectedIdObserver:Observable<any> | null = null;
  //selectedId:string | null = null;
  customer: Partial<Customer>;

  constructor(
    private uiErrorHandler: UIErrorHandler,
    private storage: StorageService,
  ) {
    this.customer = Customer.createEmpty();
  }

  ngOnInit() {
    // If the user is coming to this page from somewhere else (like global search),
    // automatically load the selected merchant info.

    //this.selectedIdObserver = this.route.queryParams.pipe(map((p) => p['id']));
    //this.selectedIdObserver.subscribe(value => {

    let c = this.storage.getSelectedCustomer();

    if (c) {
      this.uiErrorHandler.handleError('you must select a customer first');
    }
  }
}
